<template>
  <div class="file-preview">
    <LmTooltip> {{ file.name }} </LmTooltip>
    <div v-if="file.type.includes('image')" class="image">
      <img :src="file.url" />
    </div>

    <div v-else class="no-image">
      <q-icon :class="iconClass" />
    </div>

    <div class="overlay">
      <q-btn v-if="fileIsUploaded" flat round color="white" size="0.7rem" icon="fas fa-download" @click="download" />

      <q-btn flat round color="white" size="0.7rem" icon="fas fa-trash" @click="$emit('delete')" />
    </div>
    <span class="file-name">{{ file.name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    file: Object
  },

  computed: {
    fileIsUploaded() {
      return !this.file.url.startsWith('data')
    },

    iconClass() {
      const { type, name } = this.file
      if (type.includes('pdf')) return 'fiv-sqo fiv-size-md fiv-icon-pdf'
      else if (name.includes('doc') || type.includes('msword')) return 'fiv-sqo fiv-size-md fiv-icon-doc'
      else if (name.includes('xlsx') || name.includes('xls') || type.includes('spreadsheet'))
        return 'fiv-sqo fiv-size-md fiv-icon-xls'
      else if (type.includes('text')) return 'fiv-sqo fiv-size-md fiv-icon-txt'
      return 'fal fa-file-times fa-3x text-faded'
    }
  },

  methods: {
    download() {
      this.$store.dispatch('downloadMedia', this.file.id, { root: true })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .file-preview {
    display grid
    grid-template-rows 1fr 30px
    position relative
    height 120px
    width 100px
    border-radius 5px
    overflow hidden
    box-shadow 0px 0px 5px 0px #3b3535
    text-align center

    > .file-name {
      display: inline-block;
      text-overflow: ellipsis;
      padding: 5px 12px;
      overflow: hidden;
      white-space: nowrap;
    }

  .image, .no-image {
    height 100%
    display grid
  }

  > .image > img {
    height 100%
    width 100%
    object-fit cover
  }

  > .no-image {
    display grid
    justify-content center
    align-items center
  }

  > .overlay {
    display none
  }

  &:hover .overlay {
    height 100%
    position absolute
    top 0
    width 100%
    display grid
    justify-content center
    align-items center
    background: rgba(0, 0, 0, .7);
  }
}
</style>
